import RootStore from 'bzx-common/src/stores/RootStore'
import { inject, observer } from 'mobx-react'
import React from 'react'
import FeatureNetworkSwitch from '../FeatureNetworkSwitch'

/**
 * For now it's only possible to switch to non Ethereum chain.
 * So button switch appears only for other chains.
 */
const NetworkError = (props: any) => {
  const rootStore = props.rootStore as RootStore
  const { chainId, networkDetails: connectedNetworkDetails } = rootStore.web3Connection

  return (
    <div className="flex-center flex-col padded-2">
      <div className="txt-size-2 txt-center txt-muted">
        You are currently connected to{' '}
        <b>{connectedNetworkDetails ? connectedNetworkDetails.chainName : `Chain ${chainId}`}</b>.
      </div>

      <FeatureNetworkSwitch allChainsSwitches feature="staking">
        <p className="margin-bottom-2">Please switch to one of these chains.</p>
      </FeatureNetworkSwitch>
    </div>
  )
}

export default inject('rootStore')(observer(NetworkError))
